import { analiticaInstance } from '@payments-checkout/shared/plugins/analitica/analitica.events';
import { Checkbox } from '@stone-payments/jade';
import { useFormContext } from 'react-hook-form';
import { useIntl } from 'react-intl';
import { RecurrenceFields } from '../../types/billingInformation.types';

type RecurrenceAgreementProps = {
  accountName?: string;
};

export const RecurrenceAgreement = ({
  accountName,
}: RecurrenceAgreementProps) => {
  const { formatMessage } = useIntl();
  const {
    register,
    formState: { errors },
  } = useFormContext<RecurrenceFields>();

  const label =
    (accountName ?? '').length > 0
      ? `${formatMessage({ id: 'recurrence.acceptance.disclaimer.withAccount' })} ${accountName}.`
      : formatMessage({ id: 'recurrence.acceptance.disclaimer.withoutAccount' });


  return (
    <div className="flex mt-jade-400">
      <Checkbox
        id={`recurrenceAgreement`}
        label={label}
        data-testid="recurrence-acceptance-checkbox"
        {...register('allow-recurrence', {
          onChange: (event) =>
            analiticaInstance.events.billingPage.automaticChargeOptInSelected(
              event.target.checked
            ),
        })}
        error={!!errors['allow-recurrence']?.message}
        supportText={
          errors['allow-recurrence']?.message &&
          formatMessage({id: errors['allow-recurrence']?.message})
        }
      />
    </div>
  );
};
